import React, { useState } from 'react';
import api from '../utils/api';
import {
  Box,
  TextField,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  CircularProgress,
  Checkbox,
  FormControlLabel
} from '@mui/material';
import Avatar from 'react-avatar-edit';

const categories = [
  'Managing Committee',
  'Organizing Committee 2024',
  'Past President - KTM',
  'Former Secretary KTM',
  'Speaker',
  'Invitee',
  'Media',
  'Crew',
  'Volunteer',
  'Sponsor',
  'Transport Team',
  'Food Court Crew',
  'House Keeping',
  'India Tourism',
  'Kerala Tourism',
  'Software Support',
  'Entry Pass',
  'PR & Media - MD Niche',
  'Wifi Support',
  'Event Team'
];

const CreatePass = ({ onPassCreated, eventName }) => {
  const [formData, setFormData] = useState({
    name: '',
    category: '',
    pass_type: '',
    title: '',
    photo: null,
    event: eventName
  });
  const [preview, setPreview] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value,
      ...(name === 'category' ? { pass_type: value } : {})
    }));
  };

  const onClose = () => {
    setPreview(null);
  };

  const onCrop = (preview) => {
    setPreview(preview);
  };

  const onBeforeFileLoad = (elem) => {
    if (elem.target.files[0].size > 2000000) {
      alert("File is too big!");
      elem.target.value = "";
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');
    setSuccess('');

    try {
      const response = await api.post('/buyers/entry-passes/', {
        ...formData,
        photo: preview,
        event: eventName
      });
      setSuccess('Pass created successfully!');
      setFormData({
        name: '',
        category: '',
        pass_type: '',
        title: '',
        photo: null,
        event: eventName
      });
      setPreview(null);
      onPassCreated();
    } catch (error) {
      setError('Failed to create pass. Please try again.');
      console.error('Error creating pass:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box 
      component="form" 
      onSubmit={handleSubmit} 
      sx={{ 
        maxWidth: 400, 
        margin: 'auto', 
        maxHeight: '80vh',
        overflowY: 'auto',
        padding: 2,
      }}
    >
      <Typography variant="h5" gutterBottom>
        Create New Pass - {eventName}
      </Typography>
      <TextField
        fullWidth
        margin="normal"
        name="name"
        label="Name"
        value={formData.name}
        onChange={handleInputChange}
        required
      />
      <TextField
        fullWidth
        margin="normal"
        name="title"
        label="Title"
        value={formData.title}
        onChange={handleInputChange}
      />
      <FormControl fullWidth margin="normal">
        <InputLabel>Category</InputLabel>
        <Select
          name="category"
          value={formData.category}
          onChange={handleInputChange}
          required
        >
          {categories.map((category) => (
            <MenuItem key={category} value={category}>{category}</MenuItem>
          ))}
        </Select>
      </FormControl>
      
      <Box sx={{ mt: 2, mb: 2 }}>
        <Typography variant="subtitle1" gutterBottom>
          Upload Photo
        </Typography>
        <Avatar
          width={390}
          height={295}
          onCrop={onCrop}
          onClose={onClose}
          onBeforeFileLoad={onBeforeFileLoad}
          label="Choose a photo"
        />
      </Box>
      
      {error && (
        <Typography color="error" sx={{ mt: 2 }}>
          {error}
        </Typography>
      )}
      {success && (
        <Typography color="success.main" sx={{ mt: 2 }}>
          {success}
        </Typography>
      )}
      
      <Button
        type="submit"
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 3 }}
        disabled={isSubmitting}
      >
        {isSubmitting ? <CircularProgress size={24} /> : 'Create Pass'}
      </Button>
    </Box>
  );
};

export default CreatePass;